import { createRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'gke-options',
});

export const externalSecretRouteRef = createRouteRef({
  id: 'external-secret',
});

export const addExternalSecretRouteRef = createRouteRef({
  id: 'add-external-secret',
});

export const InstallExternalSecretRouteRef = createRouteRef({
  id: 'install-external-secret',
});

export const SetUpExternalSecretRouteRef = createRouteRef({
  id: 'set-up-external-secret',
});
